import { updateUserDetails } from '@store/slices/authSlice';
import axios from 'axios';
import { endpoints } from '@api/apis';
import { store } from '@store/newstore';

const fetchUserDetails = () => {
  const url = endpoints.userInfo;
  axios
    .post(url, { onboardingPartnerCode: '' })
    .then(res => {
      store.dispatch(updateUserDetails(res.data));
      return res.data;
    })
    .catch(err => {
      console.log('err', err);
    });
};
export default fetchUserDetails;
